module.exports = __webpack_public_path__ + "img/img4.7e937d9a.png";